import React, {forwardRef, Component, createElement} from 'react'
import PropTypes from 'prop-types'
import {noop} from '@republic/foundation/lang/function'
import {keys} from '@republic/foundation/lang/object'
import {config} from '../utils/config'
import {isNative} from '../utils/is'
import {omit} from '../utils/lang'
import {create} from '../utils/style-manager'
import {color, type as colorType} from '../utils/styles/background-color'
import {border, type as borderType} from '../utils/styles/border'
import {radius, type as radiusType} from '../utils/styles/border-radius'
import {shadow, type as shadowType} from '../utils/styles/box-shadow'
import {cursor, type as cursorType} from '../utils/styles/cursor'
import {dimensions, type as dimensionsType} from '../utils/styles/dimensions'
import {display, type as displayType} from '../utils/styles/display'
import {margin, type as marginType} from '../utils/styles/margin'
import {opacity, type as opacityType} from '../utils/styles/opacity'
import {overflow, type as overflowType} from '../utils/styles/overflow'
import {padding, type as paddingType} from '../utils/styles/padding'
import {position, type as positionType} from '../utils/styles/position'
import {positions, type as positionsType} from '../utils/styles/positions'
import {transition, type as transitionType} from '../utils/styles/transition'
import {layer, type as layerType} from '../utils/styles/z-index'

const
    native = isNative(),
    types = {
        className: PropTypes.string,
        tag: (
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node,
                PropTypes.func
            ])),
        children: PropTypes.node,

        margin: marginType,
        padding: paddingType,

        width: dimensionsType,
        height: dimensionsType,
        maxWidth: dimensionsType,
        maxHeight: dimensionsType,
        minWidth: dimensionsType,
        minHeight: dimensionsType,

        layer: layerType,
        position: positionType,
        positions: positionsType,

        border: borderType,
        color: colorType,
        cursor: cursorType,
        display: displayType,
        opacity: opacityType,
        overflow: overflowType,
        radius: radiusType,
        shadow: shadowType,
        transition: transitionType
    },

    Particle = (
        class Particle extends Component {
            static propTypes = types

            constructor(props) {
                super(props)
                this.destroy = noop
            }

            addStyle = () => {
                const
                    {destroy, style} = (
                        create(
                            'bits-particle',
                            this.props,
                            {
                                ...margin(this.props.margin),
                                ...padding(this.props.padding),

                                ...(!native ? {boxSizing: 'border-box'} : {}),
                                ...dimensions('width', this.props.width),
                                ...dimensions('height', this.props.height),
                                ...dimensions('maxWidth', this.props.maxWidth),
                                ...dimensions('maxHeight', this.props.maxHeight),
                                ...dimensions('minWidth', this.props.minWidth),
                                ...dimensions('minHeight', this.props.minHeight),

                                ...layer(this.props.layer),
                                ...position(this.props.position),
                                ...positions(this.props.positions),

                                ...border(this.props.border),
                                ...color(this.props.color),
                                ...cursor(this.props.cursor),
                                ...display(this.props.display),
                                ...opacity(this.props.opacity),
                                ...overflow(this.props.overflow),
                                ...radius(this.props.radius),
                                ...shadow(this.props.shadow),
                                ...transition(this.props.transition)
                            }))

                this.destroy()
                this.destroy = destroy

                return style
            }

            componentWillUnmount() {
                this.destroy()
            }

            render() {
                const
                    {props, addStyle} = this,
                    {children, tag, forwardRef, ...rest} = props

                return (
                    createElement(
                        tag || config('Particle').tag,
                        {
                            ref: forwardRef,
                            ...omit(rest, keys(types)),
                            ...addStyle(),
                        },
                        children))
            }
        })

export default forwardRef((props, ref) => (
    <Particle forwardRef={ref} {...props} />
))
